import { GenerateUrl } from "@/core/Services/GlobalFunctions";
import ApiService from "@/core/Axios/ApiService";
import ConfigurationService from "@/core/Services/ConfigurationService";
import { StatisticsData } from "./StatisticsTypes";

export default class StatisticsService {
  async getStatistics({
    from,
    to,
    parkingSpaceIds,
    clientTimeZoneName,
  }: {
    from: string;
    to: string;
    parkingSpaceIds: number[];
    clientTimeZoneName: string;
  }): Promise<StatisticsData> {
    const url = GenerateUrl({
      path: "/api/statistics",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
      config: {
        From: from,
        To: to,
        ParkingSpaceIds: parkingSpaceIds,
        ClientTimeZoneName: clientTimeZoneName,
      },
    });
    const response = await ApiService.get(url);
    return this._mapStatisticsData(response.data);
  }

  private _mapStatisticsData(data: StatisticsData): StatisticsData {
    return {
      occupationsByHour: data.occupationsByHour.map((item: any) => ({
        calculatedDate: item.calculatedDate,
        enters: item.enters,
        exits: item.exits,
        load: item.load,
      })),
      averageSpaceSessions: data.averageSpaceSessions.map((item: any) => ({
        spaceId: item.spaceId,
        spaceName: item.spaceName,
        averageSession: item.averageSession,
      })),
    };
  }
}
